export default __webpack_public_path__ + "static/media/portfolio-98.4cad7419.jpg";